import script from "./Anomaly.vue?vue&type=script&setup=true&lang=js"
export * from "./Anomaly.vue?vue&type=script&setup=true&lang=js"

import "./Anomaly.vue?vue&type=style&index=0&id=17bb66f7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17bb66f7"]])

export default __exports__